<template>
	<div v-click-outside="closeOptions">
		<div class="dropdown">
			<div ref="toggle" class="cursor-pointer opacity-30 hover:opacity-100" @click="toggle">
				<svg-icon icon="three-dots" class="w-5 h-5"></svg-icon>
			</div>
			<div v-if="opened" ref="popup" class="dropdown-popup">

				<div v-if="post.can_make_post_public" class="dropdown-popup-item">
					<svg-icon icon="globe" class="w-4 h-4"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">Публичный пост</div>
						<formcontrol
							class="text-sm toggle-danger"
							type="toggle"
							:model-value="post.is_public"
							@update:modelValue="togglePublic"
						></formcontrol>
					</div>
				</div>

				<div v-if="post.can_pin_own_posts" class="dropdown-popup-item">
					<svg-icon icon="pin-angle-fill" class="w-4 h-4"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">Закрепить</div>
						<formcontrol
							class="text-sm toggle-primary"
							type="toggle"
							:model-value="post.pinned"
							@update:modelValue="togglePinnedOwn"
						></formcontrol>
					</div>
				</div>

				<div v-if="post.can_pin_posts" class="dropdown-popup-item">
					<svg-icon icon="pin-angle-fill" class="w-4 h-4"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">В рамку</div>
						<formcontrol
							class="text-sm toggle-primary"
							type="toggle"
							:model-value="post.is_pinned"
							@update:modelValue="togglePinned"
						></formcontrol>
					</div>
				</div>

				<div v-if="post.can_promote" class="dropdown-popup-item">
					<svg-icon icon="fire" class="w-4 h-4"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">Продвигать</div>
						<formcontrol
							class="text-sm toggle-primary"
							type="toggle"
							:model-value="post.is_promoted"
							@update:modelValue="togglePromoted"
						></formcontrol>
					</div>
				</div>

				<div v-if="post.can_mark_post_best" class="dropdown-popup-item">
					<svg-icon icon="star" class="w-4 h-4"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">Лучшее</div>
						<formcontrol
							class="text-sm toggle-primary"
							type="toggle"
							:model-value="post.is_best"
							@update:modelValue="toggleBest"
						></formcontrol>
					</div>
				</div>

				<div v-if="!muted" @click.prevent="mute" class="dropdown-popup-item">
					<svg-icon icon="eye-slash-fill" class="w-4 h-4"></svg-icon>
					<div>Cкрыть пост</div>
				</div>

				<div v-if="muted" @click.prevent="unmute" class="dropdown-popup-item">
					<svg-icon icon="eye-fill" class="w-4 h-4"></svg-icon>
					<div>Вернуть пост</div>
				</div>

				<div v-if="post.can_complain" @click.prevent="complain" class="dropdown-popup-item">
					<svg-icon icon="rat" set="local" class="w-4 h-4 shrink-0"></svg-icon>
					<div>Пожаловаться</div>
				</div>

				<a v-if="post.can_edit" :href="'/p/' + post.id + '/edit'" class="dropdown-popup-item">
					<svg-icon icon="pencil-fill" class="w-4 h-4"></svg-icon>
					<div>Редактировать</div>
				</a>

				<div v-if="post.can_unpublish && post.is_published" @click.prevent="unpublish"
					 class="dropdown-popup-item">
					<svg-icon icon="file-excel-fill" class="w-4 h-4"></svg-icon>
					<div>Распубликовать</div>
				</div>

				<div v-if="post.can_move" @click.prevent="move" class="dropdown-popup-item">
					<svg-icon icon="magic" class="w-4 h-4"></svg-icon>
					<div>Перенести</div>
				</div>

				<div v-if="post.can_mark_post_adult"
					 class="dropdown-popup-item">
					<svg-icon icon="eyeglasses" class="w-3 h-3"></svg-icon>
					<div class="flex items-center flex-1">
						<div class="flex-1">Заблюрить</div>
						<formcontrol
							class="text-sm toggle-primary"
							type="toggle"
							:model-value="post.adult_content"
							@update:modelValue="markAdult"
						></formcontrol>
					</div>
				</div>

				<div v-if="post.can_ban" @click.prevent="warnUser" class="dropdown-popup-item dropdown-popup-item-red">
					<svg-icon icon="exclamation-triangle-fill" class="w-4 h-4"></svg-icon>
					<div>Предупредить</div>
				</div>

				<div v-if="post.can_ban" @click.prevent="banUser" class="dropdown-popup-item dropdown-popup-item-red">
					<svg-icon icon="lock-fill" class="w-4 h-4"></svg-icon>
					<div>Забанить</div>
				</div>

				<div v-if="post.can_delete" @click.prevent="deletePost"
					 class="dropdown-popup-item dropdown-popup-item-red">
					<svg-icon icon="trash-fill" class="w-4 h-4"></svg-icon>
					<div>Удалить</div>
				</div>
			</div>
		</div>

		<unpublish-dialog v-if="post.can_unpublish && opened" ref="unpublishDialog"></unpublish-dialog>
		<move-post-dialog v-if="post.can_move && opened" ref="moveDialog"></move-post-dialog>
		<complain-dialog ref="complainDialog"></complain-dialog>
		<ban-dialog v-if="post.can_ban && opened" ref="banDialog"></ban-dialog>
		<warn-dialog v-if="post.can_ban && opened" ref="warnDialog"></warn-dialog>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import ConfirmReasonDialog from "../partials/ConfirmReasonDialog";
import MovePostDialog from "../partials/MovePostDialog";
import ComplainDialog from "../partials/ComplainDialog";
import BanDialog from "../partials/BanDialog";
import WarnDialog from "../partials/WarnDialog";
import UnpublishDialog from "../partials/UnpublishDialog.vue";
import {createPopper} from '@popperjs/core';
import {nextTick} from "vue";

export default {
	props: [
		'post',
		'view',
	],
	components: {
		UnpublishDialog,
		WarnDialog,
		BanDialog,
		ConfirmReasonDialog,
		MovePostDialog,
		ComplainDialog,
	},
	data() {
		return {
			opened: false,
			muted: false,
		};
	},
	methods: {
		toggle() {
			if (this.opened) {
				this.opened = false;
			} else {
				this.opened = true;

				nextTick(() => {
					createPopper(this.$refs.toggle, this.$refs.popup, {
						placement: 'bottom-end',
					});
				})
			}
		},
		closeOptions() {
			if (this.opened) {
				this.opened = false;
			}
		},
		async complain() {
			this.$refs.complainDialog.show({
				title: 'Пожаловаться на пост',
				message: 'Укажите причину',
				okButton: 'Пожаловаться',
				isPrompt: true,
			}).then((data) => {
				Client.post('/api/v1.1/posts/' + this.post.id + '/complain', {
					reason_id: data.reason_id,
					reason: data.reason,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Жалоба отправлена модераторам',
						});
						this.opened = false
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async banUser() {
			this.$refs.banDialog.show({
				title: 'Забанить пользователя',
				okButton: 'Забанить',
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.post.user_id + '/ban', {
					days: data.days,
					reason: data.reason,
					permanent: data.permanent,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был забанен',
						});
						this.opened = false
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async banUserShort() {
			this.$refs.banDialog.show({
				title: 'Короткий бан',
				okButton: 'Остудить',
				days: false
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.post.user_id + '/ban', {
					days: 1 / 8,
					reason: data.reason,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был временно забанен',
						});
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async warnUser() {
			this.$refs.warnDialog.show({
				title: 'Предупредить пользователя',
				okButton: 'Предупредить',
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.post.user_id + '/warn', {
					message: data.message,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был предупрежден',
						});
						this.opened = false
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		markAdult() {
			Client.patch('/api/v1.1/posts/' + this.post.id + '/mark-adult')
				.then(response => {
					notify({
						type: 'success',
						text: 'Cохранено',
					});
					this.post.adult_content = !this.post.adult_content;
				})
				.catch(error => {
				});
		},
		async unpublish() {
			this.$refs.unpublishDialog.show()
				.then(data => {
					Client
						.patch('/api/v1.1/posts/' + this.post.id + '/unpublish', {
							message: data.reason,
							republish_status: data.republish_status,
						})
						.then(response => {
							this.opened = false
							this.$emit('postUnpublished')
						})
						.catch(error => {
						});
				})
				.catch(error => {
					console.log(error);
				});

		},
		mute() {
			Client.patch('/api/v1.1/posts/' + this.post.id + '/mute', {
				mute: 1,
			}).then(response => {
				notify({
					type: 'success',
					text: 'Пост скрыт из вашей ленты',
				});
				this.$emit('muted');
				this.muted = true;
				this.opened = false;
			}).catch(error => {
			});
		},
		unmute() {
			Client.patch('/api/v1.1/posts/' + this.post.id + '/mute', {
				mute: 0,
			}).then(response => {
				notify({
					type: 'success',
					text: 'Пост убран из скрытых',
				});
				this.$emit('unmuted');
				this.muted = false;
				this.opened = false;
			}).catch(error => {
			});
		},
		deletePost() {
			if (confirm('Точно?')) {
				Client.delete('/api/v1.1/posts/' + this.post.id)
					.then(response => {
						if (this.view) {
							window.location.href = this.post.author.url;
						} else {
							this.$emit('postDeleted')
						}
						this.opened = false;
					})
					.catch(error => {
					});
			}
		},
		move() {
			this.$refs.moveDialog
				.show({
					title: 'Перенести статью?',
					message: 'Выберите подсайт',
					okButton: 'Перенести',
					isPrompt: true,
					channel_id: this.post.channel_id,
					author: this.post.author,
				})
				.then(form => {
					Client
						.post('/api/v1.1/posts/' + this.post.id + '/move', {
							channel_id: form.channel_id,
							message: form.reason,
						})
						.then(response => {
							notify({
								type: 'success',
								text: 'Пост перенесен в выбранный подсайт',
							});
							this.$emit('postUpdated', response.data.data);
							this.opened = false;
						})
						.catch(error => {
							notify({
								type: 'error',
								text: error.response?.data?.message ?? 'Не удалось перенести пост в выбранный подсайт',
							});
						});
				})
				.catch(error => {
					console.log(error);
				});
		},
		togglePromoted() {
			Client
				.patch('/api/v1.1/posts/' + this.post.id + '/promote')
				.then(response => {
					notify({
						type: 'success',
						text: 'Успешно!',
					});
					this.post.is_promoted = response.data.data.is_promoted;
				})
				.catch(error => {
				});
		},
		toggleBest() {
			Client
				.patch('/api/v1.1/posts/' + this.post.id + '/best')
				.then(response => {
					notify({
						type: 'success',
						text: 'Успешно!',
					});
					this.post.is_best = response.data.data.is_best;
				})
				.catch(error => {
				});
		},
		togglePinned() {
			Client
				.patch('/api/v1.1/posts/' + this.post.id + '/pin')
				.then(response => {
					notify({
						type: 'success',
						text: 'Успешно!',
					});
					this.post.is_pinned = response.data.data.is_pinned;
				})
				.catch(error => {
				});
		},
		togglePinnedOwn() {
			Client
				.patch('/api/v1.1/posts/' + this.post.id + '/pin-own-post', {
					pin: this.post.pinned ? 0 : 1,
				})
				.then(response => {
					this.post.pinned = response.data.data.pinned;

					let message = this.post.pinned ? 'Пост закреплен' : 'Пост откреплен';
					message += this.post.channel_id ? ' в подсайте' : ' в блоге';

					notify({
						type: 'success',
						text: message,
					});
				})
				.catch(error => {
				});
		},
		togglePublic() {
			Client
				.patch('/api/v1.1/posts/' + this.post.id + '/public')
				.then(response => {
					this.post.is_public = response.data.data.is_public;
					notify({
						type: 'success',
						text: this.post.is_public
							? 'Пост помечен публичным'
							: 'Пост доступен только для зарегистрированных пользователей',
					});
				})
				.catch(error => {
				});
		},
	}
}
</script>
